var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.locales,"label":_vm.$t('general.language'),"prepend-icon":"translate","color":"primary"},model:{value:(_vm.locale),callback:function ($$v) {_vm.locale=$$v},expression:"locale"}})}
var staticRenderFns = []

export { render, staticRenderFns }